let swipers = {
    hero: {
        slider: false,
        elem: $('.js-slider-hero'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: true,
            slidesPerView: 3,
            centeredSlides: true,
            spaceBetween: 0,
            cssMode: false,
            // breakpoints: {
            //     1024: {
            //         slidesPerView: 'auto',
            //         centeredSlides: false,
            //         cssMode: true,
            //         loop: false,
            //     }
            // },
            pagination: {
                el: '.js-slider-hero-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-slider-hero-next',
                prevEl: '.js-slider-hero-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            on: {
                init: function () {
                    swipers.hero.active = true;
                },
                slideChange: function () {
                    setTimeout(function () {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
    realization: {
        slider: false,
        elem: $('.js-realization-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 13,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            pagination: {
                el: '.js-realization-slider-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-realization-slider-next',
                prevEl: '.js-realization-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                359: {
                    spaceBetween: 6,
                    slidesPerView: 1.2,
                    slidesPerGroup: 1
                },
                599: {
                    spaceBetween: 10,
                    slidesPerView: 1.4,
                    slidesPerGroup: 1
                },
                767: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
            on: {
                init: function () {
                    swipers.realization.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
    infobox3: {
        slider: false,
        elem: $('.js-slider-infobox-3'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            pagination: {
                el: '.js-slider-infobox-3-pagination',
                clickable: true
            },
            on: {
                init: function () {
                    swipers.infobox3.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
};

rEvent.on('Window.resized', function() {
    checkSliders(swipers);
});


let realizationsSearchRequestInstance = null;
let $lightgalleryInstance = null;

$(function() {
    $('.js-hero-gallery').lightGallery(
        $.extend({}, lightGallerySettings, {
            selector: '.js-lightbox',
            thumbnail: true,
            exThumbImage: 'data-thumb',
            galleryId: 1
        })
    );

    checkSliders(swipers);

    $('.js-hero-gallery').on('onBeforeOpen.lg', function() {
        freezeScroll();
    });

    $('.js-hero-gallery').on('onCloseAfter.lg', function() {
        unfreezeScroll();
    });

    $('.js-realizations-search-open').on('click', function() {
        $('.js-realizations-search-form').toggle();
    })

    $('.js-realizations-search-close').on('click', function() {
        $('.js-realizations-search-form').hide();

        if (realizationsSearchRequestInstance) {
            realizationsSearchRequestInstance.abort();
        }
    });

    $('.js-realizations-search-form').on('submit', function(e) {
        e.preventDefault();
    });

    $('.js-realizations-search-form').validate({
        submitHandler: function(form) {
            const $form = $(form);

            $form.find('[type="submit"]').prop('disabled', true).addClass('is-loading');

            if (realizationsSearchRequestInstance) {
                realizationsSearchRequestInstance.abort();
            }

            realizationsSearchRequestInstance = $.get('/realizacie-vyhladavanie-obrazkov', {
                q: $form.find('[name="custom_realizations_search"]').val(),
                limit: 100,
                format: '__FORMAT__'
            }, function (data) {
                if (!data.status) {
                    Eshop.alert(data.message, { type: 'error' });
                    return
                }

                if (!data.data || !data.data.length) {
                    Eshop.alert(data.message, { type: 'info-alt' });
                    return
                }

                $lightgalleryInstance = $('.js-realizations-search-dynamic-gallery').lightGallery(
                    $.extend({}, lightGallerySettings, {
                        thumbnail: true,
                        hash: false,
                        dynamic: true,
                        dynamicEl: data.data.map(function(item) {
                            return {
                                src: item.imageSrc.replace('__FORMAT__', 'default'),
                                thumb: item.imageSrc.replace('__FORMAT__', 'sm'),
                                subHtml: item.title
                            }
                        })
                    })
                );

                $lightgalleryInstance.on('onCloseAfter.lg', function() {
                    $lightgalleryInstance.data('lightGallery').destroy(true);
                    $lightgalleryInstance.off('onCloseAfter.lg');
                });
            }, "json").fail(function(xhr, status, error) {
                Eshop.alert(error, { type: 'error' });
            }).always(function() {
                $form.find('[type="submit"]').prop('disabled', false).removeClass('is-loading');
            });
        }
    });
});
